<template>
  <div>
    <tabAdvertisements />

    <div class="col-sm-7 col-md-6 col-xl-12 fl wrapper_order_table">
 Social

    
    </div>
  </div>
</template>
<script>
import tabAdvertisements from "../advertisements/tabAdvertisements";
export default {
   components: {
    tabAdvertisements
  }
};
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/profileDashboard/vendor/advertisements/social.vue